export default function getDaysBetwen(dataComparar:any){
    let dataFormatada = new Date(dataComparar)
    let dataAtual = new Date()

    let millisecondsPerDay = 1000 * 60 * 60 * 24;
    let millisBetween = dataFormatada.getTime() - dataAtual.getTime();
    let days = millisBetween / millisecondsPerDay;

    return Math.floor(days) + 1
}